import {FetchStatus} from '../common/FetchStatus.enum';
import useTypedSelector from '../common/useTypedSelector';
import {ItemEntity} from './types';

export function useSelectItem(id: string): {
  item: ItemEntity;
  fetchStatus: FetchStatus;
  error: Error;
} {
  const result = useTypedSelector(state => {
    const item = state.pagewebLayout.entities.items[id];
    const fetchStatus = state.pagewebLayout.fetchStatus[id];
    const error = state.pagewebLayout.errors[id];
    return {
      item,
      fetchStatus,
      error,
    };
  });
  return result;
}
